import { useEffect, useState } from 'react';
import {
  DOC_CLIPBOARD_EVENT,
  getCopiedDoc,
} from '../utils/docClipboard';

/** Live view of the in-app copied doc (`{ docId, title }` or null). */
export function useCopiedDoc() {
  const [, setTick] = useState(0);

  useEffect(() => {
    const onChange = () => setTick((n) => n + 1);
    window.addEventListener(DOC_CLIPBOARD_EVENT, onChange);
    return () => window.removeEventListener(DOC_CLIPBOARD_EVENT, onChange);
  }, []);

  return getCopiedDoc();
}
